
export interface DLLedgerTemplate {
  name: string
  signed: boolean
}

export interface DLSettings {
  ledgerTemplates: DLLedgerTemplate[]
}

export interface UpdateDLLedgerTemplateInput {
  name: string
  signed: boolean
}

export interface UpdateDLSettingsInput {
  ledgerTemplates: UpdateDLLedgerTemplateInput[]
}

export function settingsToUpdateInput(settings: DLSettings): UpdateDLSettingsInput {
  return {
    ledgerTemplates: settings.ledgerTemplates.map(({name, signed}) => ({
      name,
      signed,
    }))
  };
}